var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#8DC351"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4276 21.2219C40.826 17.2418 37.022 17.0428 32.4172 17.8388L30.8155 12.2667L27.4119 13.2617L29.0136 18.6348C28.6892 18.7154 28.3319 18.8287 27.955 18.9482L27.955 18.9482C27.4017 19.1237 26.8062 19.3125 26.2107 19.4308L24.609 13.8587L21.2054 14.8537L22.8071 20.4259C22.4067 20.5254 22.0563 20.6249 21.706 20.7244C21.3556 20.8239 21.0052 20.9234 20.6048 21.0229L16 22.6149L17.001 26.197C17.001 26.197 19.6038 25.401 19.4036 25.401C20.805 25.003 21.4057 25.6 21.8061 26.396L23.608 32.7642H24.0084L23.608 32.9632L26.2107 41.9184C26.2107 42.3164 26.2107 43.1124 25.2096 43.5104L22.8071 44.3065L23.2075 48.4856L27.6121 47.2915L30.0147 46.6945L31.6163 52.2667L35.0199 51.2716L33.4182 45.6995C34.4193 45.5005 35.2201 45.3015 36.2211 44.9035L37.8228 50.4756L41.2264 49.4806L39.6247 43.9085C45.2306 41.9184 48.8343 39.3313 47.8333 33.7592C47.0324 29.3811 44.4297 27.9881 40.826 28.1871C42.828 26.197 43.6289 24.207 42.4276 21.2219ZM41.2264 34.7542C42.2853 38.4382 36.6544 40.1118 33.6595 41.0019C33.257 41.1216 32.902 41.2271 32.6174 41.3214L30.4151 33.7592C30.7308 33.6807 31.1261 33.5645 31.5778 33.4316C34.5627 32.5536 40.0091 30.9515 41.2264 34.7542ZM29.9723 30.2159C32.366 29.5397 37.5261 28.0822 36.4214 24.605C35.5158 21.0044 30.5141 22.6154 28.0862 23.3974C27.8302 23.4798 27.6029 23.553 27.4119 23.61L29.414 30.3761C29.5749 30.3281 29.763 30.275 29.9723 30.2159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBch);
export default __webpack_public_path__ + "static/media/BCH.83e9c61195241ae27b119c6ba84372db.svg";
export { ForwardRef as ReactComponent };